import { StaffFormValues } from '@/types/staff';

export const initialStaffForm: StaffFormValues = {
  uuid: '',
  firstName: '',
  lastName: '',
  title: '',
  email: '',
  phoneNumber: '',
  businessPhoneNumber: '',
  bio: '',
  avatarUrl: '',
  avatarDisplayName: '',
  isSandboxUser: false,
  sandboxPassword: '',
};
